<template src="./Login.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthCard from "@/components/AuthCard";
import CredentialsForm from "@/components/CredentialsForm";
import TwoFactorForm from "@/components/TwoFactorForm";
import { notificationsModule } from "@/store/modules/notifications";
import { NotificationsActions } from "@/store/modules/notifications/actions";
import { accountModule } from "@/store/modules/account";
import { AccountActions } from "@/store/modules/account/actions";
import { AccountMutations } from "@/store/modules/account/mutations";
import { AccountGetters } from "@/store/modules/account/getters";
import { Routes } from "@/router/routes";
import Errors from "./BackendResponseErrors.json";

export default defineComponent({
    components: { AuthCard, CredentialsForm, TwoFactorForm },
    computed: {
        ...accountModule.mapGetters({
            loginResult: AccountGetters.LoginResult,
            loading: AccountGetters.Loading,
            errors: AccountGetters.Errors
        })
    },
    data() {
        return {
            twoFactorEmail: ""
        };
    },
    methods: {
        ...accountModule.mapActions({
            logUserIn: AccountActions.LogUserIn,
            logUserInTwoFactor: AccountActions.LogUserInTwoFactor,
            getTwoFactorResetToken: AccountActions.GetTwoFactorResetToken
        }),
        ...accountModule.mapMutations({
            setErrors: AccountMutations.SetErrors
        }),
        ...notificationsModule.mapActions({
            showError: NotificationsActions.NotifyError
        }),
        async submitLogin(email: string, password: string): Promise<void> {
            await this.logUserIn({ username: email, password });
            if (this.loginResult?.isMultiFactorRequired) {
                this.twoFactorEmail = email;
                return;
            }
            this.$router.push(
                (this.$route.query.redirecturl as string) ?? Routes.Home
            );
        },
        async submitTwoFactor(twoFactorPassword: string): Promise<void> {
            if (twoFactorPassword.length === 6) {
                await this.twoFactorLoginAsync(twoFactorPassword);
            } else {
                await this.twoFactorResetAsync(twoFactorPassword);
            }
        },
        async twoFactorLoginAsync(twoFactorPassword: string): Promise<void> {
            await this.logUserInTwoFactor({ twoFactorPassword });
            this.$router.push(
                (this.$route.query.redirecturl as string) ?? Routes.Home
            );
        },
        async twoFactorResetAsync(twoFactorPassword: string): Promise<void> {
            const token = await this.getTwoFactorResetToken({
                userName: this.twoFactorEmail,
                recoveryCode: twoFactorPassword
            });
            this.$router.push(Routes.TwoFactorActivation + "?token=" + token);
        }
    },
    watch: {
        errors(errors: string[] | null) {
            if (!errors) return;
            if (errors[0].includes(Errors.BadRequest.Error)) {
                this.showError(Errors.BadRequest.Message);
            } else {
                this.showError(errors[1] ?? Errors.Default.Message);
            }
        }
    }
});
</script>
